import { PRODUCT, textOn, type WorkspaceSummary } from '@nolens/domain';
import { cx } from '@nolens/ui';
import { UserIcon } from './Icons';

/**
 * Quadrado de um espaço: numa equipa, a inicial na cor do kit de marca (sem kit, no tom do
 * símbolo Nolens); no espaço pessoal, a pessoa.
 */
export function SpaceTile({
  ws,
  size = 22,
  className,
}: {
  ws: Pick<WorkspaceSummary, 'name' | 'kind' | 'accent'>;
  size?: number;
  className?: string;
}) {
  const style = { width: size, height: size, borderRadius: Math.round(size * 0.28) };
  if (ws.kind === 'personal')
    return (
      <span
        aria-hidden="true"
        className={cx(
          'inline-flex shrink-0 items-center justify-center bg-surface-2 text-text-2 shadow-[inset_0_0_0_1px_var(--border)]',
          className,
        )}
        style={style}
      >
        <UserIcon size={Math.round(size * 0.66)} />
      </span>
    );
  const bg = ws.accent ?? PRODUCT.tile;
  return (
    <span
      aria-hidden="true"
      className={cx('inline-flex shrink-0 items-center justify-center font-semibold', className)}
      style={{ ...style, background: bg, color: textOn(bg), fontSize: Math.round(size * 0.5) }}
    >
      {ws.name.trim().charAt(0).toUpperCase() || '·'}
    </span>
  );
}
